import { Component, Input } from '@angular/core';

@Component({
  selector: 'round-progress',
  templateUrl: 'round-progress.component.html',
  styleUrls: ['round-progress.component.scss']
})
export class RoundProgressComponent {

  @Input() set score(val) {
    if (this.smooth) {
      this.smoothCount(this.scoreValue, val, 500);
    } else {
      this.scoreValue = val;
    }
  };
  @Input() smooth = false;
  @Input() isAvatar = false;
  @Input() small = false;
  @Input() ultraSmall = false;
  @Input() thin = false;
  scoreValue = 25;
  
  constructor() {
  }

  private smoothCount(start, end, duration) {
    const stepTime = 25;
    const steps = duration / stepTime;
    const stepSize = (end - start) / steps;
    let currentCount = start;

    const intervalId = setInterval(() => {
      currentCount += stepSize;
      this.scoreValue = Math.round(currentCount);
      if ((stepSize > 0 && currentCount >= end) || (stepSize < 0 && currentCount <= end)) {
          clearInterval(intervalId);
      }
    }, stepTime);
  }

}
